import { render, staticRenderFns } from "./Version.vue?vue&type=template&id=5d8c3dba&scoped=true&"
import script from "./Version.vue?vue&type=script&lang=js&"
export * from "./Version.vue?vue&type=script&lang=js&"
import style0 from "./Version.vue?vue&type=style&index=0&id=5d8c3dba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8c3dba",
  null
  
)

export default component.exports